import { Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import AuthCard from "../../pages/auth/AuthCard";
import { IUser } from "../../stateManagement/reducers/authReducer";
import { ICustomer } from "../../stateManagement/reducers/customersReducer";
import Form from "./From";

interface IRequestOrderProps {
  customer?: ICustomer;
  user?: IUser;
  setOpened: (truth: boolean) => void;
}

const RequestOrder: React.FC<IRequestOrderProps> = ({
  customer,
  user,
  setOpened,
}) => {
  return (
    <AuthCard maxWidth={600}>
      <Grid
        container
        spacing={3}
        alignItems="center"
        justifyContent="center"
        height={"100%"}
      >
        <Grid item xs={12}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="baseline"
            sx={{ mb: { xs: -0.5, sm: 0.5 } }}
          >
            <Typography variant="h3">New Order</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Form
            customerId={
              user && user?.customerId
                ? user.customerId
                : customer
                  ? customer._id
                  : ""
            }
            setOpened={setOpened}
          />
        </Grid>
      </Grid>
    </AuthCard>
  );
};

export default RequestOrder;
